// extracted by mini-css-extract-plugin
export default {"base":"style_base__bKwih","info":"style_info__3Idhi","root":"style_root__tOejH"};